import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { OutrasReceitasInserirComponent } from './outras-receitas-inserir.component';

@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: OutrasReceitasInserirComponent }
    ])],
    exports: [RouterModule]
})
export class OutrasReceitasInserirRoutingModule { }
